import { render } from "./PhoneData.vue?vue&type=template&id=30ff5e0e"
import script from "./PhoneData.vue?vue&type=script&lang=js"
export * from "./PhoneData.vue?vue&type=script&lang=js"

import exportComponent from "/Users/thanaphon/Documents/LTC/ltc-poc-prod/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__